import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';
import SimulatorRendersPortfolio from '../../../components/simulator/SimulatorRendersPortfolio';
import Spinner from '../../../components/Spinner';
import ModalErrorFetch from '../../../components/UI/ModalErrorFetch';
import { InvestmentContext } from '../../../context/InvestmentContext';
import useModal from '../../../hooks/custom/useModal';
import { useGetModelsPortfolioById } from '../../../hooks/useGetModelsPortfolioById';
import useGetSecurityList from '../../../hooks/useGetSecurityList';
import { modelsPortfolioChartById } from '../../../utils/modelsPortfolioChart';
import { onRefresh } from '../../../utils/refreshPage';

const SimulatorPortfolio = () => {
  const { id } = useParams();
  const { isShowing, toggle } = useModal();

  const {
    data: dataSecurityList,
    error: errorGetSecurityList,
    loading: loadingGetSecurityList,
  } = useGetSecurityList();

  const {
    data: dataPortolioById,
    loading: loadingDataPortolioById,
    error: errorDataPortolioById,
  } = useGetModelsPortfolioById({
    modelId: id,
  });

  const dataPortfolioSimulationById = dataPortolioById?.getModelById;
  const chartModels = dataSecurityList?.getSecurityList;

  const dataPortfolioModels = modelsPortfolioChartById(dataPortfolioSimulationById, chartModels);

  const dataChart = dataPortfolioModels[0];

  const {
    formData,
    setSend,
    setFormData,
    setDataSimulation,
    setDataSimulationResult,
    setFormDataAndPersist,
  } = useContext(InvestmentContext);

  const dataChartHeader = dataPortfolioSimulationById?.[0];

  useEffect(() => {
    if (dataPortolioById?.getModelById) {
      const simulationDataPortfolio = dataPortolioById.getModelById.scenarios || [];

      setDataSimulationResult(
        Array.isArray(simulationDataPortfolio) ? simulationDataPortfolio : [],
      );
    }
  }, [dataPortolioById]);

  if (loadingDataPortolioById || loadingGetSecurityList) {
    return <Spinner />;
  }

  if (errorDataPortolioById || errorGetSecurityList) {
    return (
      <ModalErrorFetch
        message='Lo sentimos, algo no salio bien acá....'
        error={errorDataPortolioById || errorGetSecurityList}
        open={!isShowing}
        onClose={toggle}
        refresh={onRefresh}
      />
    );
  }

  return (
    <>
      <HeaderLayout type='product' mode='portfolio' dataChart={dataChartHeader} />

      <SimulatorRendersPortfolio
        formData={formData}
        setSend={setSend}
        setFormData={setFormData}
        setDataSimulation={setDataSimulation}
        dataChart={dataChart}
        setFormDataAndPersist={setFormDataAndPersist}
      />
    </>
  );
};

export default SimulatorPortfolio;
